var getBasketStorageKey = function (token) {
    return "".concat(token, "-basket");
};
export var getBasketFromStorage = function (storage, token) {
    var savedBasketJson = storage.getItem(getBasketStorageKey(token));
    return savedBasketJson ? JSON.parse(savedBasketJson) : null;
};
export var saveBasketToStorage = function (storage, token, basketJson) {
    storage.setItem(getBasketStorageKey(token), JSON.stringify(basketJson));
};
export var removeBasketFromStorage = function (storage, token) {
    storage.removeItem(getBasketStorageKey(token));
};
